import React from 'react';
import { Form, Input } from 'antd';
const FormItem = Form.Item;

const FieldText = ({ data }) => {
	const { label, name, required } = data || {};

	return (
		<FormItem label={label} name={name} required={required}>
			<Input />
		</FormItem>
	);
};

export default FieldText;
